module.exports = __webpack_public_path__ + "static/img/Joanie.5561042.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/Joanie.jpg
// module id = 201
// module chunks = 1